<div>
  <div class="ui {{loadingIsActive ? 'active' : ''}} dimmer">
    <div class="ui text large loader">Loading</div>
  </div>
  <ng-container *ngIf="( !this._uiHelper.isOnlyDeposit && ALLOWED_TO_START && this.loginService.LoginState != 0 && !this.SecondScreenIsActive && this.tournamentsService._allscreenheader != 1 ) ||( ALLOWED_TO_START && this._uiHelper.isOnlyDeposit && !this.SecondScreenIsActive)">
    <all-screen-header></all-screen-header>
  </ng-container>
  <ng-container *ngIf="this._uiHelper.isOnlyDeposit === false">
    <comp_allscreen style="touch-action: none;user-select: none" *ngIf="ALLOWED_TO_START && this.loginService.LoginState != 0 && !this.SecondScreenIsActive"></comp_allscreen>
  </ng-container>
  <ng-container *ngIf="this._uiHelper.isOnlyDeposit === true">
    <img src="../../../Images/only_deposit_terminal.png" style="width: 100%; object-fit: contain" />
  </ng-container>

    <comp_login style="touch-action: none;user-select: none" *ngIf="ALLOWED_TO_START && this.loginService.LoginState == 0 && !this.SecondScreenIsActive"></comp_login>
    <!--<comp_secondscreen style="touch-action: none;user-select: none" *ngIf="this.SecondScreenIsActive && false"></comp_secondscreen>-->
    <scoreBox style="touch-action: none;user-select: none" *ngIf="ALLOWED_TO_START && this.SecondScreenIsActive"></scoreBox>

  <comp_ticket_keyboard_modal></comp_ticket_keyboard_modal>
</div>
